import HelpFAQs from './components/HelpFAQs';

export default HelpFAQs;



// WEBPACK FOOTER //
// ./src/routes/HelpFAQs/index.js